import { render, staticRenderFns } from "./formBaking.vue?vue&type=template&id=cd956d88&scoped=true"
import script from "./formBaking.vue?vue&type=script&lang=js"
export * from "./formBaking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd956d88",
  null
  
)

export default component.exports